/**
 * @param {any} x
 * @return {number | Null}
 */
export const safeParseInt = (x) => {
  try {
    return parseInt(x)
  } catch (_error) {
    return null
  }
}
